export async function apiInstance( url, options={}) {
    const defaultHeaders = {
        'Content-type': 'application/json',
    };

    const config = {
        method: options.method || 'GET',  // Default to GET
        headers: {...defaultHeaders, ...options.headers},
        body: options.body ? JSON.stringify(options.body) : null,
        ...options,
    };

    try {
        const response = await fetch(url, config);
        if(!response.ok) {
            throw new Error(`HTTP error! status ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch(error) {
        console.error(`Error in fetchInstance: ${error}`)
        throw error;
    }
}